import React, { Component } from 'react';
import { Router } from "react-router-dom";
import { createHashHistory } from 'history';
import PropTypes from 'prop-types';

import TopUILayer from './components/ui/TopUILayer.jsx';
import { ThreeJSWorld } from 'web-store-modules/packages/web-store-three-world';
import RoomRoutes from './components/room/RoomRoutes.jsx';
import { AppContext } from "./AppContext.jsx";
import AppLoadingIcon from './AppLoadingIcon.jsx';
import { WebStoreUILayer } from 'web-store-modules/packages/web-store-ui-layer';
import AddToCartContextComponent from './components/ui/add-to-cart/AddToCartContextComponent.jsx';
import { MediaContextProvider } from './components/ui/MediaContext.jsx';
import FlatImageSceneContextComponent from './components/flat-image-scene/FlatImageSceneContextComponent';
import { THREE_CACHE_MANAGER_OPTION, initThreeCacheManager } from 'web-store-modules/packages/three-cache-manager';
import { getStoreId } from './utils/StoreConfigManager.js';
import { isMobileDevice } from './utils/DeviceDetector.js';
import { constructUrl } from './utils/UrlConstructor.js';
import { loadUIImageAsync } from './utils/AssetLoader.js';

initThreeCacheManager(THREE_CACHE_MANAGER_OPTION.LAST_ROOM);

const history = createHashHistory();

const appStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%'
};

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showingUI: false,
            hideRoomObjects: true,
            showingLoadingIcon: false,
            showWelcomeTooltips: false,
            firstImgLoaded: false,
            currentSceneName: '',
        };

        this.onFirstFullResImageLoaded = this.onFirstFullResImageLoaded.bind(this);
        this.setLoadingIconVisibility = this.setLoadingIconVisibility.bind(this);
        this.setRoomObjectVisibility = this.setRoomObjectVisibility.bind(this);

    }

    componentDidMount() {
        // To set default dimensions.
        // Not at all happy with this approach.
        // There needs to be a way to change three js dimensions after the world has been initialized.
        // Currently the dimensions are set in the constructor, and there is no way to update those dimensions later.
        // TODO: Update WSM
        if (isMobileDevice() && getStoreId() === "62f54cb3174b1a3ffe7d574c") {
            const imageUrl = 'https://cdn.obsess-vr.com/mary-kay/global/be_back_welcome_message_mk_global.png';
            this.calculateFlatImageDims(imageUrl);
        } else {
            const mobileWidth = (window.innerHeight / 1080) * 1920;
            this.setFlatImageDims(mobileWidth, window.innerHeight)
        }
    }

    setFlatImageDims = (width, height) => {
        this.setState({ flatSceneDims: { width, height } });
    }


    calculateFlatImageDims = async (flatImageUrl) => {
        const image = await loadUIImageAsync(flatImageUrl)
        const height = image.naturalHeight;
        const width = image.naturalWidth;
        const imageRatio = height / width;

        let multiplier = 1.05

        let targetWidth = window.innerWidth * multiplier;
        let targetHeight = targetWidth * imageRatio;

        if (targetHeight < window.innerHeight) {
            targetHeight = window.innerHeight * 1.05;
            targetWidth = targetHeight / imageRatio;
        }

        this.setFlatImageDims(targetWidth, targetHeight);
    }

    onFirstFullResImageLoaded() {
        if (this.state.showingUI) {
            return;
        }
        this.setState({ showingUI: true });
        this.onFirstImageLoaded();
    }

    setLoadingIconVisibility = (isShowing, source) => {
        this.setState({ showingLoadingIcon: isShowing });
    }

    setShowWelcomeTooltips = (type) => {
        this.setState({ showWelcomeTooltips: type });
    }

    setRoomObjectVisibility = (visibility) => {
        this.setState({ hideRoomObjects: !visibility });
    }

    setCurrentSceneName = (scene) => {
        this.setState({ currentSceneName: scene });
    }

    onFirstImageLoaded = () => {
        if (this.state.firstImgLoaded) {
            return;
        }
        this.setState({ firstImgLoaded: true });
    }

    render() {
        const { hideLogo } = this.props;
        const { showingUI, hideRoomObjects, showingLoadingIcon, currentSceneName, firstImgLoaded, showWelcomeTooltips, flatSceneDims } = this.state;

        const appContextValue = {
            showingLoadingIcon: showingLoadingIcon,
            setShowWelcomeTooltips: this.setShowWelcomeTooltips,
            onFirstImageLoaded: this.onFirstImageLoaded,
            onFirstFullResImageLoaded: this.onFirstFullResImageLoaded,
            setLoadingIconVisibility: this.setLoadingIconVisibility,
            setCurrentSceneName: this.setCurrentSceneName,
            currentSceneName,
        };
        return (
            <div id='app' style={appStyle}>
                <AppContext.Provider value={appContextValue}>
                    <AppLoadingIcon />
                    <AddToCartContextComponent>
                        {flatSceneDims && <ThreeJSWorld
                            history={history}
                            rootNodeId='app'
                            connectControllerImmediately={false}
                            enableDrag={false}
                            mobileFlatImageDimension={flatSceneDims}
                        >
                            <MediaContextProvider>
                                <FlatImageSceneContextComponent>
                                    <TopUILayer
                                        showWelcomeTooltips={showWelcomeTooltips}
                                        hideLogo={hideLogo}
                                        firstImgLoaded={firstImgLoaded}
                                        showingUI={showingUI}
                                        setLoadingIconVisibility={this.setLoadingIconVisibility}
                                        setRoomObjectVisibility={this.setRoomObjectVisibility}
                                    />
                                    <WebStoreUILayer>
                                        <Router history={history}>
                                            <RoomRoutes hideRoomObjects={hideRoomObjects} />
                                        </Router>
                                    </WebStoreUILayer>
                                </FlatImageSceneContextComponent>
                            </MediaContextProvider>
                        </ThreeJSWorld>}
                    </AddToCartContextComponent>
                </AppContext.Provider>
            </div>
        );
    }
}

App.propTypes = {
    hideLogo: PropTypes.bool
}

export default App;
